/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `dtg` - dt/g
* `` - (empty)
* `kgm3` - kg/m3
* `kilogram` - Kilogram
* `percent` - %
* `%wm` - % w.m
* `ppm` - ppm
* `text` - Text
* `mg/Kg w.m.` - mg/Kg w.m.
* `g/10min` - g/10min
 */
export type UnitEnum = typeof UnitEnum[keyof typeof UnitEnum];


export const UnitEnum = {
  dtg: 'dtg',
  kgm3: 'kgm3',
  kilogram: 'kilogram',
  percent: 'percent',
  '%wm': '%wm',
  ppm: 'ppm',
  text: 'text',
  'mg/Kg_wm': 'mg/Kg w.m.',
  'g/10min': 'g/10min',
} as const;
